import React from "react";
import { Modal, Button } from "antd";
import { AlertOutlined } from "@ant-design/icons";

function NavigationWarningModal({
  open,
  isSessionSaved,
  pause,
  onBack,
  onLeave,
  onPauseAndSave,
}) {
  return (
    <Modal
      title={
        <div style={{ textAlign: "left" }}>
          {isSessionSaved ? "Leave Saved Training Session?" : "Leave Training Session?"}
        </div>
      }
      open={open}
      rootClassName="liquid-glass-modal"
      onCancel={onBack}
      footer={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", gap: 12 }}>
            <Button type="default" onClick={onBack} style={{ minWidth: 120 }}>
              Back to Session
            </Button>
            {!isSessionSaved && (
              <Button
                type="primary"
                className="primary-glass-btn"
                onClick={onPauseAndSave}
                style={{ minWidth: 140 }}
              >
                {pause ? "Save" : "Pause and Save"}
              </Button>
            )}
          </div>

          <Button
            danger={!isSessionSaved}
            type={isSessionSaved ? "primary" : undefined}
            onClick={onLeave}
            style={
              isSessionSaved
                ? {
                    minWidth: 120,
                    backgroundColor: "#1890ff",
                    borderColor: "#1890ff",
                    color: "white",
                  }
                : {
                    minWidth: 120,
                    backgroundColor: "rgba(220, 38, 38, 1)",
                    borderColor: "rgba(220, 38, 38, 1)",
                    color: "white",
                  }
            }
          >
            Leave
          </Button>
        </div>
      }
      centered
      styles={{
        mask: {
          backdropFilter: "blur(8px) saturate(120%)",
          backgroundColor: "rgba(255,255,255,0.15)",
        },
      }}
    >
      <div style={{ textAlign: "left" }}>
        <p
          style={{
            fontWeight: 700,
            color: isSessionSaved ? "rgba(52, 199, 89, 0.95)" : "rgba(200,0,0,0.95)",
            fontSize: 16,
            marginBottom: 8,
          }}
        >
          <AlertOutlined />{" "}
          {isSessionSaved
            ? "Your training session has been saved"
            : "You have an active training session in progress"}
        </p>
        <p style={{ marginBottom: 0 }}>
          {isSessionSaved
            ? "Your progress is safely stored, but if you leave you won’t be able to continue this session later."
            : "If you leave now, you’ll lose your current progress. Are you sure you want to continue?"}
        </p>
      </div>
    </Modal>
  );
}

export default NavigationWarningModal;


